import React from "react";

export default function Event() {
  return (
    <>
      <section className="events" id="events">
        <h1 className="heading">our events</h1>
        <div className="box-container">
          <div className="box">
            <img src={"./images/event1.jpg"} alt="" />
            <div className="content">
              <h3>1 may, 2021 / 09:00am to 06:00pm</h3>
              <a href="" className="title">
                saving the environment and planting the tress
              </a>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. A
                provident quidem sapiente placeat odit modi architecto
                accusantium numquam ea tempore?
              </p>
              <a href="#" className="btn">
                participate
              </a>
            </div>
          </div>
          <div className="box">
            <img src={"./images/event2.jpg"} alt="" />
            <div className="content">
              <h3>1 may, 2021 / 09:00am to 06:00pm</h3>
              <a href="#" className="title">
                saving the environment and planting the tress
              </a>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. A
                provident quidem sapiente placeat odit modi architecto
                accusantium numquam ea tempore?
              </p>
              <a href="#" className="btn">
                participate
              </a>
            </div>
          </div>
          <div className="box">
            <img src={"./images/event3.jpg"} alt="" />
            <div className="content">
              <h3>1 may, 2021 / 09:00am to 06:00pm</h3>
              <a href="#" className="title">
                saving the environment and planting the tress
              </a>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. A
                provident quidem sapiente placeat odit modi architecto
                accusantium numquam ea tempore?
              </p>
              <a href="#" className="btn">
                participate
              </a>
            </div>
          </div>
          <div className="box">
            <img src={"./images/event4.jpg"} alt="" />
            <div className="content">
              <h3>1 may, 2021 / 09:00am to 06:00pm</h3>
              <a href="#" className="title">
                saving the environment and planting the tress
              </a>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. A
                provident quidem sapiente placeat odit modi architecto
                accusantium numquam ea tempore?
              </p>
              <a href="#" className="btn">
                participate
              </a>
            </div>
          </div>
          <div className="box">
            <img src={"./images/event5.jpg"} alt="" />
            <div className="content">
              <h3>1 may, 2021 / 09:00am to 06:00pm</h3>
              <a href="#" className="title">
                saving the environment and planting the tress
              </a>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. A
                provident quidem sapiente placeat odit modi architecto
                accusantium numquam ea tempore?
              </p>
              <a href="#" className="btn">
                participate
              </a>
            </div>
          </div>
          <div className="box">
            <img src={"./images/event6.jpg"} alt="" />
            <div className="content">
              <h3>1 may, 2021 / 09:00am to 06:00pm</h3>
              <a href="#" className="title">
                saving the environment and planting the tress
              </a>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. A
                provident quidem sapiente placeat odit modi architecto
                accusantium numquam ea tempore?
              </p>
              <a href="#" className="btn">
                participate
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
